"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var ArrowLeftShadyIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 29 48", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("defs", null,
            React.createElement("filter", { id: "shadow", x: "-10%", y: "-10%", width: "120%", height: "120%" },
                React.createElement("feOffset", { result: "offOut", in: "SourceAlpha" }),
                React.createElement("feGaussianBlur", { result: "blurOut", in: "offOut", stdDeviation: "2" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "blurOut" })),
            React.createElement("path", { id: "arrow-left-path", d: "M7.771 33.77l27.598.079v1.917l-27.597-.08v.006h-2.07L5.697 6.155h2.069L7.77 33.77z", strokeWidth: "1" })),
        React.createElement("use", { stroke: "currentColor", fill: "currentColor", transform: "rotate(45 18.533 25.788)", filter: "url(#shadow)", fillRule: "evenodd", xlinkHref: "#arrow-left-path" }),
        React.createElement("use", { fill: "currentColor", stroke: "currentColor", transform: "rotate(45 18.533 25.788)", fillRule: "evenodd", xlinkHref: "#arrow-left-path" })));
};
ArrowLeftShadyIcon.displayName = 'ArrowLeftShadyIcon';
exports.default = ArrowLeftShadyIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftShadyIcon.js.map